import React, { useState, useEffect } from "react";
import axios from "axios";
import { redirect, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';
import PregnancyLossModal from "./PregnancyLossModal";
import TakeYourTimeModal, { TakeYourTimeModalyesn } from "./TakeYourTimeModal";
import PregnancyThankYouModal from "./PregnancyThankYouModal";
import PregnancyAssessmentModal from "./PregnancyAssessmentModal";
import DueDateModal from "./DueDateModal";
import BabyCountModal from "../Security/BabyCountModal";
import TLossModal from "./TLossmodal";
import PostpartumThankYouPopup from "../UserProfileManagement/AccountSetting/PostpartumThankYouPopup";

dayjs.extend(customParseFormat); // Enable custom parsing format

const ShowNote = () => {
  const { t, i18n } = useTranslation();
  const [notifications, setNotifications] = useState([]);
  const [visibleNotifications, setVisibleNotifications] = useState(); // Initial visible notifications
  const email = useSelector((state) => state.email.email);
  const dashboardData = useSelector((state) => state.dashboard.dashboardData.ServiceDetails);
  const webinarlink = useSelector((state) => state.dashboard.dashboardData.WebinarLink);
  const token = localStorage.getItem("AccessToken");
  const navigate = useNavigate();
  const contract = useSelector((state) => state.userData);
  const userTypePremier = contract.userData.Premiere;
  const [providersContent, setProvidersContent] = useState("");
  const [showModal,setShowModal] = useState(false);
  const [modalMessage,setModalMessage] = useState("");
  const feedLinks = contract.userData.BenefitsOverview;
  const {isChatVisible, toggleChat, showChat } = useChat();

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  const [loading, setLoading] = useState(true);
  
  const [showPregnancyPopup, setShowPregnancyPopup] = useState(false);
  const [popupStep, setPopupStep] = useState(1);
  const [babyCount, setBabyCount] = useState(1);
  const [pregnancyTerm, setPregnancyTerm] = useState("");
  const [deliveryDate, setDeliveryDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [doYouHaveBaby, setDoYouHaveBaby] = useState("");
  const [pregnancyLinks, setPregnancyLinks] = useState({ WebLink: "", VideoLink: "", DocumentLink: "" });

  const [showPregnancyAssessmentT, setShowPregnancyAssessmentT] = useState(false);
  const [dueDateT, setDueDateT] = useState(null);
  const [pregnancyLinksT, setPregnancyLinksT] = useState({ WebLink: "", VideoLink: "", DocumentLink: "" });
  const [babyCountT, setBabyCountT] = useState(1);
  const [tPopupStep, setTPopupStep] = useState(1);
  const [tLossOrigin, setTLossOrigin] = useState(null); // Track origin for TLossModal

  // Reusable pregnancy API save function
  const savePregnancyApi = async ({
    doYouHaveBaby,
    babyCount = null,
    pregnancyTerm = "",
    deliveryDate = null,
    setLinks,
    setModal,
    setMessage,
    isTFlow = false
  }) => {
    const payload = {
      EmailID: contract.userData.EmailID,
      MemberID: contract.userData.MemberID,
      Contract: contract.userData.ContractIdentified,
      DoYouHaveBaby: doYouHaveBaby,
      PregnencyTerm: isTFlow ? "" : pregnancyTerm,
      DeliveryDate: deliveryDate ? dayjs(deliveryDate).format("YYYY-MM-DD") : null,
      ...(isTFlow ? {} : { BabyCount: String(babyCount) })
    };
    const dataParams = new URLSearchParams();
    dataParams.append("_Params", JSON.stringify(payload));
    try {
      const response = await axios.post(
        Endpoints.SaveMultiplePregnency,
        dataParams,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data && response.data.Result === 1) {
        setLinks({
          WebLink: response.data.WebLink,
          VideoLink: response.data.VideoLink,
          DocumentLink: response.data.DocumentLink,
        });
        // setModal && setModal(true);
      } else {
        setMessage && setMessage(response.data.ResultText || "Save failed");
        setModal && setModal(true);
      }
    } catch (error) {
      setMessage && setMessage("API error");
      setModal && setModal(true);
    }
  };

  const handlePopupYes = () => {
    setDoYouHaveBaby("Yes");
    setPopupStep(2); // Step 2: BirthTermPopup (term selection)
  };

  const handleTermSelect = (term) => {
    setPregnancyTerm(term);
    setPopupStep(3); // Step 3: BabyCountPopup
  };

  const handleBabyCountSelect = async (count) => {
    setBabyCount(count);
    await savePregnancyApi({
      doYouHaveBaby: "Yes",
      babyCount: count,
      pregnancyTerm,
      deliveryDate,
      setLinks: setPregnancyLinks,
      setModal: setShowModal,
      setMessage: setModalMessage,
      isTFlow: false
    });
    setPopupStep(4); // Step 4: PregnancyThankYouModal
  };

  const handlePopupNo = async() => {
    setDoYouHaveBaby("No");
    await savePregnancyApi({
      doYouHaveBaby: "No",
      babyCount: 0,
      pregnancyTerm : null,
      deliveryDate : null,
      setLinks: setPregnancyLinks,
      setModal: setShowModal,
      setMessage: setModalMessage,
      isTFlow: false
    });
    setPopupStep(5); // Step 5: PregnancyLossModal
  };

  const handleLossModalNotNow = () => {
    setPopupStep(6); // Step 6: TakeYourTimeModal
  };

  const normalizeDate = (dateString) => {
    try {
      const parsedDate = dayjs(dateString, "MMM D YYYY h:mma");
      if (!parsedDate.isValid()) throw new Error(t('dateformat'));
      return parsedDate.toDate();
    } catch (error) {
      console.error(t('normalizing'), dateString, error);
      return null;
    }
  };

  const loadNotifications = async () => {
    const dataParams = new URLSearchParams();
    dataParams.append("_Params", JSON.stringify({ EmailID: email, DeviceType: "PatientPortal", }));

    try {
      const response = await axios.post(
        Endpoints.Notificationload,
        dataParams,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        const notificationsData = response.data.map((notification, index) => ({
          id: index + 1,
          title: notification.NotificationHeader,
          description: notification.NotificationBody,
          date: normalizeDate(notification.NotificationDate),
          rawDate: notification.NotificationDate,
          redirectScreen: notification.RedirectScreen,
          redirectFlag: notification.RedirectFlag,
        }));
        setNotifications(notificationsData);
        // Check for RedirectFlag === "P" and show popup
        if (notificationsData.some(n => n.redirectFlag === "P")) {
          setShowPregnancyPopup(true);
          setPopupStep(1);
        }
        // Only follow T flow if at least one notification has redirectFlag === "T"
        if (notificationsData.some(n => n.redirectFlag === "T")) {
          setShowPregnancyAssessmentT(true);
          setTPopupStep(1);
        }
      }
    } catch (error) {
      console.error(t('loadnotification'), error);
    }finally {
      setLoading(false); 
    }
  };

  useEffect(() => {
    loadNotifications();
  }, []);

  const handleBackClick = () => {
    navigate("/home"); // Navigate to home page
  };


  const formatDate = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) {
      return "";
    }
    const options = { month: "short" };
    const month = date.toLocaleDateString("en-US", options);
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${month} ${day} ${year} ${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  const fetchFeedContent = async () => {
    try {
        if (!feedLinks) {
            console.error(t('feedlinkerror'));
            return;
        }

        const params = {
            URL: feedLinks,
            EmailID: contract.userData.EmailID,
            DeviceType: "PatientPortal",
        };

        const response = await axios.post(
            Endpoints.Getjson,
            `_Params=${encodeURIComponent(JSON.stringify(params))}`,
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        const responseData = response.data;

        console.log(t('feedresponse'), responseData);

        // Extracting Providers content
        const providersData = responseData?.rss?.channel?.item?.providers;
        if (providersData) {
            const providersArray = providersData.provider || []; // Ensure providers is an array
            const providerText = providersData.providertext?.["#cdata-section"] || providersData.providertext || ""; // Handle CDATA or plain text


            // Generate HTML content dynamically
            const providersHTML = `
                <providers>
                    ${providersArray
                        .map(
                            (provider) => `
                        <provider>
                            <providerlink>${provider.providerlink || ""}</providerlink>
                            <providerlogo>${provider.providerlogo || ""}</providerlogo>
                        </provider>
                    `
                        )
                        .join("")}
                        ${providerText ? `<providertext>${providerText}</providertext>` : ""}
                </providers>
            `;

            setProvidersContent(providersHTML);
            console.log(t('providerscontent'), providersHTML);
        } else {
            console.error(t('noproviders'));
        }
    } catch (error) {
        console.error(t('fectchingfeed'), error.message);
    }
};

useEffect(() => {
  if (userTypePremier === "No" && feedLinks) {
      fetchFeedContent();
  }
}, [userTypePremier, feedLinks]);
  
  
   const handleNotificationClick = (notification) => {
   //notification.redirectScreen = "PregnanacyAssessment";
    if (notification.redirectScreen === "MyAppointments") {
      navigate("/appointment-cancellation-reschedule");
    } else if (notification.redirectScreen === "ScheduleConsult") {
      navigate("/book-appointment");
    } else if (notification.redirectScreen?.toLowerCase().includes("education")) {
      navigate("/load-service-titles")
    }
    else if(notification.redirectScreen === "BusOutcome"){
      navigate("/benefits-accumulator");
    }
    else if(notification.redirectScreen === "RxAuthorization"){
      navigate("/rx-authorization");
    }
    else if(notification.redirectScreen === "TreatmentAuthorization"){
      navigate("/treatment-authorization");
    }
    else if(notification.redirectScreen === "UnderstandingBenefits"){
      navigate("/benefits-landingpage");
    }
    else if(notification.redirectScreen === "PregnancyAssessment"){
      navigate("/maternity-assessment");
    }
    else if(notification.redirectScreen === "BHAssessment"){
      navigate("/bhassessment");
    }
    else if(notification.redirectScreen === "Wincentive"){
      navigate("/incentive-landingpage");
    }
    else if(notification.redirectScreen === "Logmetrics"){
      navigate("/pregnancy");
    }
    else if(notification.redirectScreen === "Webinar"){
      if(webinarlink){
        window.location.href = webinarlink;
      } 
      else{
        console.error(t('webnarlink'));
      }
    }
    else if (notification.redirectScreen === "ProviderSearch") {
      // Handle ProviderSearch based on user type
      if (userTypePremier === "Yes") {
        navigate("/load-findcare-list");
      } else {
          if (!providersContent) {
              console.error(t('providercontent'));
          } else {
              navigate("/iframe-page", {
                  state: {
                      htmlContent: providersContent,
                  },
              });
          }
      }}
    
  };

// --- T Flow Modal Logic ---
// 1: PregnancyAssessmentModal
// 2: BabyCountModal
// 3: DueDateModal
// 4: PregnancyThankYouModal
// 5: PregnancyLossModal
// 6: TakeYourTimeModal
// 100: TLossModal
// 101: TakeYourTimeModal after TLossModal

const handlePregnancyAssessmentTYes = () => {
  setTPopupStep(2); // Show BabyCountModal
};

const handleBabyCountSelectT = (count) => {
  setBabyCountT(count);
  setTPopupStep(3); // DueDateModal
};

const handleDueDateModalTNext = async (date) => {
  setDueDateT(date);
  // Call savePregnancyApi only here (after due date is selected)
  await savePregnancyApi({
    doYouHaveBaby: "Yes",
    babyCount: babyCountT,
    deliveryDate: date,
    setLinks: setPregnancyLinksT,
    setModal: null,
    setMessage: setModalMessage,
    isTFlow: true
  });
  setTPopupStep(4); // Thank you modal
};

const handlePregnancyAssessmentTNo = async () => {
  // Call savePregnancyApi immediately if "No" is clicked
  await savePregnancyApi({
    doYouHaveBaby: "No",
    babyCount: null,
    deliveryDate: null,
    setLinks: setPregnancyLinksT,
    setModal: null,
    setMessage: setModalMessage,
    isTFlow: true
  });
  setTLossOrigin("No"); // Track origin
  setTPopupStep(100); // Show TLossModal
};

const handlePregnancyAssessmentTYesNoLongerPregnant = async () => {
  // Call savePregnancyApi with YesN (no longer pregnant)
  await savePregnancyApi({
    doYouHaveBaby: "YesN",
    babyCount: null,
    deliveryDate: null,
    setLinks: setPregnancyLinksT,
    setModal: null,
    setMessage: setModalMessage,
    isTFlow: true
  });
  setTLossOrigin("YesN"); // Track origin
  setTPopupStep(103); // Show TLossModal
};

const handleLossModalTNotNow = () => {
  setTPopupStep(6); // Take your time modal
};
const handleLossModalTTalk = () => {
  setTPopupStep(0);
  navigate("/book-appointment");
};
const handleTakeYourTimeModalTClose = () => {
  setTPopupStep(0);
};
const handleThankYouModalTExplore = () => {
  setTPopupStep(0);
  navigate("/feedServices", {
    state: {
      link: pregnancyLinksT.WebLink,
      description: "Maternity",
      videolink: pregnancyLinksT.VideoLink,
      documentlink: pregnancyLinksT.DocumentLink,
    },
  });
};

const handleTLossModalNotNow = () => {
  if (tLossOrigin === "No") {
    setTPopupStep(101); // Show TakeYourTimeModal
  } else if (tLossOrigin === "YesN") {
    setTPopupStep(102); // Show TakeYourTimeModalyesn
  } else {
    setTPopupStep(0); // Fallback
  }
};

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
  
    return (
    <>

      {isHighmarkPortal ? 
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
      <button className="win-back-btn me-1" onClick={handleBackClick}>
        <span>
          <i className="bi bi-chevron-left"></i>
        </span>
      </button>
      <h2 className="page-heading">{t('notificationlabel')}</h2>
    </div> :
    <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
      <button className="win-back-btn me-1" onClick={handleBackClick}>
        <span>
          <i className="bi bi-chevron-left"></i> {t('back')}
        </span>
      </button>
      <h2 className="page-heading">{t('notificationlabel')}</h2>
    </div>
      }

      <div className="notification-wrapper">
        {/* Notifications */}
        {notifications.slice(0, visibleNotifications).map((notification) => (
          <div key={notification.id} className="notification-container">
            {/* Top Date */}
            
            <div
              className={`notification-item ${notification.read ? "read" : ""}`}
              onClick={() => handleNotificationClick(notification)}
            >
              <div className="notification-content-wrapper">
                <h3 className="notification-heading">{notification.title}</h3>
                <p className="notification-content">{notification.description}</p>
                <div className="row align-items-center">
                  <div className="col-md-6">
                    {isHighmarkPortal &&( notifications[0].title !== "No Notifications" )&& (
                      <button
                        className="win-btn-secondary-w-content highmark-option-no-border me-md-2"
                        onClick={(e) => {
                          e.stopPropagation(); // prevent parent click
                          handleNotificationClick(notification);
                        }}
                      >
                        Click Here
                      </button>
                    )}
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span className="notification-time-below">
                      {formatDate(notification.date)}
                    </span>                
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Error Modal */}
      <ErrorModal
        show={showModal}
        message={modalMessage}
        onClose={()=>setShowModal(false)}
      />
      {showPregnancyPopup && popupStep !== 4 && (
        <div className="modal show custom-modall" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title">Pregnancy Assessment</h5> */}
                <button type="button" className="btn-close"  onClick={() => setShowPregnancyPopup(false)}></button>
              </div>
              <div className="modal-body text-center">
                {popupStep === 1 && (
                  <>
                  <p>Tap to answer a few quick questions so we can better support you.</p>
                    <h5 style={{fontSize:"1.5rem"}}>Did you give birth? </h5>
                    <div className="d-flex justify-content-center mt-3">
                    <button className="btn win-btn-secondary me-2" onClick={handlePopupNo}>No</button>
                    <button className="btn win-btn-primary " onClick={handlePopupYes}>Yes</button>
                    
                    </div>
                  </>
                )}
                {popupStep === 2 && (
                  <>
                  <p>Congratulations! We're here for you every step of the way as you navigate postpartum.</p>
                    <h5 style={{fontSize:"1.5rem"}}>Was it a full-term or pre-term birth?</h5>
                    
                    <button className="btn win-btn-primary-full me-2 mb-2" onClick={() => handleTermSelect("Full Term")}>Full-term (37 weeks or later)</button>
                    <button className="btn win-btn-primary-full" onClick={() => handleTermSelect("Pre-term")}>Pre-term (before 37 weeks)</button>
                    
                  </>
                )}
                {popupStep === 3 && (
                  <>
                    <h5 style={{fontSize:"1.5rem"}}>Did you give birth to one baby or multiple?</h5>
                    <button className="btn win-btn-primary-full me-2 mb-2" onClick={() => handleBabyCountSelect(1)}>One baby</button>
                    <button className="btn win-btn-primary-full me-2 mb-2" onClick={() => handleBabyCountSelect(2)}>Two babies</button>
                    <button className="btn win-btn-primary-full" onClick={() => handleBabyCountSelect(3)}>Three or more</button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {showPregnancyPopup && popupStep === 5 && (
        <PregnancyLossModal
          onClose={() => setShowPregnancyPopup(false)}
          onTalk={() => {
            setShowPregnancyPopup(false);
            navigate("/book-appointment");
          }}
          onNotNow={handleLossModalNotNow}
        />
      )}
      {showPregnancyPopup && popupStep === 6 && (
        <TakeYourTimeModal onClose={() => setShowPregnancyPopup(false)} />
      )}
      {showPregnancyPopup && popupStep === 4 && (
        <PregnancyThankYouModal
          onClose={() => setShowPregnancyPopup(false)}
          onExplore={() => {
            setShowPregnancyPopup(false);
            navigate("/feedServices", {
              state: {
                link: pregnancyLinks.WebLink,
                description: "Maternity",
                videolink: pregnancyLinks.VideoLink,
                documentlink: pregnancyLinks.DocumentLink,
              },
            });
          }}
        />
      )}
      {showPregnancyAssessmentT && tPopupStep === 1 && (
        <PregnancyAssessmentModal
          show={true}
          onClose={() => setTPopupStep(0)}
          onYes={handlePregnancyAssessmentTYes}
          onYesNoLongerPregnant={handlePregnancyAssessmentTYesNoLongerPregnant}
          onNo={handlePregnancyAssessmentTNo}
        />
      )}
      {showPregnancyAssessmentT && tPopupStep === 2 && (
        <BabyCountModal
          show={true}
          onSelect={handleBabyCountSelectT}
          onClose={() => setTPopupStep(0)}
        />
      )}
      {showPregnancyAssessmentT && tPopupStep === 3 && (
        <DueDateModal
          show={true}
          onClose={() => setTPopupStep(0)}
          onNext={handleDueDateModalTNext}
        />
      )}
      {showPregnancyAssessmentT && tPopupStep === 4 && (
        <PostpartumThankYouPopup
          show={true}
          onClose={() => setTPopupStep(0)}
          onExplore={handleThankYouModalTExplore}
        />
      )}
      {showPregnancyAssessmentT && tPopupStep === 103 && (
        <PregnancyLossModal
          show={true}
          onClose={() => setTPopupStep(0)}
          onTalk={handleLossModalTTalk}
          onNotNow={handleLossModalTNotNow}
        />
      )}
      {showPregnancyAssessmentT && tPopupStep === 100 && (
        <TLossModal
          show={true}
          onClose={() => setTPopupStep(0)}
          onTalk={() => {
            setTPopupStep(0);
            navigate("/book-appointment");
          }}
          onNotNow={handleTLossModalNotNow}
        />
      )}
      {showPregnancyAssessmentT && tPopupStep === 101 && (
        <TakeYourTimeModal show={true} onClose={handleTakeYourTimeModalTClose} />
      )}
      {showPregnancyAssessmentT && tPopupStep === 102 && (
        <TakeYourTimeModalyesn show={true} onClose={() => setTPopupStep(0)} onExplore={handleTakeYourTimeModalTClose}/>
      )}
    </>
  );
};

export default ShowNote;
